import script from "./PromptModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromptModal.vue?vue&type=script&lang=ts&setup=true"

import "./PromptModal.vue?vue&type=style&index=0&id=757c18e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757c18e4"]])

export default __exports__